// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const simisear: PokeData = {
  "id": 514,
  "name": "simisear",
  "height": 10,
  "weight": 280,
  "base_experience": 174,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "leer",
    "lick",
    "fury-swipes",
    "flame-burst"
  ],
  "moves": [
    "leer",
    "lick",
    "magma-storm",
    "flare-blitz",
    "ember",
    "flamethrower",
    "fire-fang",
    "blaze-kick",
    "morning-sun",
    "fire-ball",
    "fire-punch",
    "sunny-day",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 263,
    "item": null,
    "species": [
      {
        "name": "pansear",
        "order": 514,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "simisear",
        "order": 515,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 513,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 151,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
